module.exports = __webpack_public_path__ + "static/Averta-Bold-da5923d907df8a3dfe4aed3674b37a33.woff2";